export default __webpack_public_path__ + "static/media/uicoach-hero.d427bdeb.png";